// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3MDil","selected":"Chip_selected__115Lp"};